// src/MyHorses.js
import React, { useEffect, useState } from "react";
import { db, auth } from "./firebase";
import { collection, query, where, onSnapshot, orderBy } from "firebase/firestore";

import { QRCodeCanvas } from "qrcode.react";
import { useAuthState } from "react-firebase-hooks/auth";
import { Link } from "react-router-dom"; // ✅ navigation

export default function MyHorses() {
  const [horses, setHorses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user] = useAuthState(auth);

  useEffect(() => {
    if (!user) return;

    const q = query(
      collection(db, "horses"),
      where("owner", "==", user.uid),
      orderBy("createdAt", "desc") // Firestore index needed
      
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
  const horseList = snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  // fallback sort in JS if some docs missing createdAt
  horseList.sort((a, b) => {
    const t1 = a.createdAt?.toMillis?.() || 0;
    const t2 = b.createdAt?.toMillis?.() || 0;
    return t2 - t1;
  });

  setHorses(horseList);
  setLoading(false);
});

    return () => unsubscribe();
  }, [user]);

  if (!user) {
    return <p style={{ textAlign: "center", marginTop: "2rem" }}>Please log in to view your horses.</p>;
  }

  if (loading) return <p>Loading your horses...</p>;

  return (
    <div style={{ maxWidth: "700px", margin: "2rem auto" }}>
      <h2 style={{ textAlign: "center", margin: "1rem 0" }}>My Horses</h2>

      {horses.length === 0 ? (
        <p>You haven't added any horses yet.</p>
      ) : (
        <ul style={{ listStyle: "none", padding: 0 }}>
          {horses.map((horse) => (
            <li
              key={horse.id}
              style={{
                border: "2px solid #000",
                borderRadius: "8px",
                padding: "1rem",
                marginBottom: "1rem",
                background: "#1694fa",
                display: "flex",
                flexWrap: "wrap", // ✅ responsive
                gap: "1rem",
              }}
            >
              {/* Left side: horse details */}
              <div style={{ flex: "1 1 250px", minWidth: "200px" }}>
                {/* ✅ Make horse name clickable */}
                <h3>
                  <Link
                    to={`/horse/${horse.id}`}
                    style={{ color: "white", textDecoration: "underline" }}
                  >
                    {horse.name}
                  </Link>
                </h3>
                <p>Owner: {horse.ownername}</p>
                <p>Contact: {horse.contact}</p>
                <p>Age: {horse.age}</p>
                <p>Breed: {horse.breed}</p>
                <p>Description: {horse.description || horse.Description}</p>
              </div>

              {/* Right side: image above QR */}
              <div
                style={{
                  flex: "4 1 200px",
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {horse.imageUrl && (
                  <Link to={`/horse/${horse.id}`}>
                    <img
                      src={horse.imageUrl}
                      alt={horse.name}
                      style={{
                        maxWidth: "150px",
                        borderRadius: "6px",
                        marginBottom: "0.5rem",
                        cursor: "pointer",
                      }}
                    />
                  </Link>
                )}
              </div>

              <div>
                <QRCodeCanvas
                  value={`${window.location.origin}/horse/${horse.id}`}
                  size={150}
                />
              </div>

              {/* ✅ Edit button */}
              <div style={{ marginTop: "1rem" }}>
                <Link
                  to={`/edit/${horse.id}`}
                  style={{
                    padding: "0.5rem 1rem",
                    background: "#8a0000ff",
                    color: "white",
                    borderRadius: "6px",
                    border: "2px solid #000000ff",
                    textDecoration: "none",
                    fontSize: "0.9rem",
                  }}
                >
                  ✏️ Edit
                </Link>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
